<template>
    <div>
        <div class="page">
            <div class="container"  style="padding:20px;margin-bottom:40px;">
            <div class="row align-items-center">
                <div class="col-md-4 offset-md-2">

                
              <img src="/static/geofolio-logo.svg" style="height:45px;margin-bottom:15px;margin-top:20px;margin-right:10px;float:none;">
            
                </div>
                <div class="col-md-4 text-right">
<a href="/" style="font-size:1em;"><i class="bi bi-arrow-up-left"></i> Back to main homepage</a>
                </div>
            </div>
                <div class="row justify-content-center">
                    <div class="col-md-8">
                        <div style="padding:20px;margin-top:20px;background-color:#fff;border:1px solid #ccc;" >

                            <div v-if="(profile) && (profile.is_public == false)" class="text-center">
<p>You are already logged in as user <strong>{{ profile.username }}</strong>.</p>

<p style="margin-bottom:0;">You should probably just continue to the <router-link :to="{ name: 'home' }">My Geofolio</router-link> homepage.</p>
                            </div>
               <div v-else style="padding:20px;">
                            

                            <h2 style="margin:0px 0px 20px 0px;">Log in with your Geofolio account</h2>

                            <form>
                              <div class="form-group">
                                <label for="email"  v-bind:class="{ 'is-invalid':error }">Email address</label>
                                <input ref="username" type="email" class="form-control"  v-bind:class="{ 'is-invalid':error }" id="email" aria-describedby="emailHelp" placeholder="">
                              </div>
                              <div class="form-group">
                                <label for="password"  v-bind:class="{ 'is-invalid':error }">Password</label>
                                <input ref="password" type="password" class="form-control" v-bind:class="{ 'is-invalid':error }" id="password" placeholder="">
                              </div>

                                <div v-if="error" class="is-invalid" style="padding-bottom:17px;">
                                    Authentication failed. Please check your credentials or get in touch via info@geofolio.org if you feel that an error has occurred.
                                </div>

                                <p>
                                    Don't have an account yet? You can <router-link :to="{ name: 'signup' }">sign up</router-link> for free to get started.
                                </p>


                              <div class="row">
                                <div class="col text-left">
                                    <button type="submit" ref="login" @click.prevent="login" class="btn btn-lg btn-primary" :disabled="disabled"><strong>Log in</strong></button>
                                </div>
                               </div>

                            </form>
                            </div>

         

                        </div>
                        
</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import MainHeader from '@/components/generic/MainHeader.vue'
  import Footer from '@/components/generic/Footer.vue'


  export default {
    name: 'login',
    components: {
      MainHeader, Footer
    },
    data() {
        return {
            error: false,
            disabled: false
        }
    },
      mounted() {
        //this.$refs["username"].focus()
      },
    computed: {
        count() {
            return this.$store.state.count
        },
        isValid() {
            if(this.error) {
                return "is-invalid"
            } else {
                return ""
            }
        },
        profile() {
            if(this.$store.state.profile) {
                return this.$store.state.profile
              } else {
                return this.$store.state.profile_pub;
              }
        }
  
    },
    methods: {
      logOut(dest='home') {
        const headers = {
            'X-CSRFTOKEN': this.csrfcookie()
        }
        this.$axios
           .post(process.env.VUE_APP_API+"/api/logout", null, { headers: headers })
           .then(response => {
                this.$store.commit('profile', response.data.profile)
                this.$store.commit('profile_pub', response.data.profile_pub)
                this.$router.push({name: 'login'})
           })
           .catch(error => {
               console.log("An error occurred while logging out.")
           })
      },
      login() {
        this.$refs["login"].blur()
        this.disabled = true;
        const params = {
           'username': this.$refs.username.value,
           'password': this.$refs.password.value
        }
        const headers = {
            'X-CSRFTOKEN': this.csrfcookie()
        }
        this.$axios
           .post(process.env.VUE_APP_API+"/api/login", params, { headers: headers })
           .then(response => {
                this.error = false;
                this.$store.commit('profile', response.data.profile)
                this.$store.commit('profile_pub', response.data.profile_pub)
                this.disabled = false;
                this.$router.push({name: 'home'})    

           })
           .catch(error => {
                this.error = true;
                this.disabled = false;
           })
      }
    }
  }
</script>

<style scoped>

div.page {
    font-size:1.2em;
    color:#666;
}
h1 {
    font-size:1.3em;
    font-weight:600;
    margin-top:15px;
}

h2 {
    font-size:1.2em;
    font-weight:600;
    margin-top:15px;
}

h3 {
    font-size:1.05em;
    font-weight:600;
    margin-top:15px;
}
p {
    line-height:1.4em;
}
.is-invalid {
    color: #dc3545;
}
label.is-invalid {
    font-weight:bold;
}
</style>